import { gql } from '@apollo/client';

export const getErrorPageCollection = gql`
	query getVignettenFehlerseitenCollection($lang: String) {
		vignettenFehlerseitenCollection(locale: $lang, limit: 1) {
			items {
				apiErrorSubText
				apiErrorText
				apiErrorTitle
				confirmationErrorText
				confirmationErrorTitle
				errorPageText
				errorPageTitle
				maintenanceSubtitle
				maintenanceText
				maintenanceTitle
				paymentErrorText
				paymentErrorTitle
				planRouteLabel
				planRouteLink
				purchaseErrorText
				purchaseErrorTitle
			}
		}
	}
`;
